import React, { Component } from 'react';
import CSSModules from 'react-css-modules'
// import {SlideDown} from 'react-slidedown'
import ReactTooltip from 'react-tooltip'
import { Link as ScrollLink } from 'react-scroll'
import {Row, Col} from 'react-flexbox-grid'
// import ReactPlayer from 'react-player'
import config from '../../config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Works,
  Link,
  LinkIcon,
  GetStartedInput,
  ScreenedCompanies,
  Grade,
  Changelog,
  ScrollToTop,
  AutocompleteSearch,
  FootprintDeprecated,
  FossilFuelCompaniesContent
} from '../../components'
import Styles from './HowItWorks.css'


@CSSModules(Styles)
export default class HowItWorks extends Component {
  render() {
    const title = 'How it works'
    const description = 'Get your money out of fossil fuels. Fossil Free Funds tracks thousands of mutual funds commonly found in retirement plans.'
    const url = config.domain + config.routes.howitworks

    const sriIcon = require( '../../../static/images/sri.png' )
    const ussifIcon = require( '../../../static/images/ussif-logo.png' )

    //
    return (
      <div styleName='page' id='top'>
        {container.helmet(title, description, url)}

        <ContainerDivs>
          <Row styleName='title-nav-row'>
            <Col xs={12} sm={8} styleName='title-nav-title'>
              <h1 styleName='title'>
                How it works
              </h1>
              <p styleName='subtitle'>
                Getting started,
                methodology,
                and fossil fuel company lists
              </p>
              <p styleName='lede'>
                Fossil Free Funds sources financial data from Morningstar, an investment research company. We use Morningstar’s mutual fund and stock data to analyze funds and find investments in fossil fuel companies. Our database covers thousands of the most popular mutual funds, the type of investments most common in retirement plans like employer-offered 401(k)s.
              </p>
            </Col>

            <Col xs={12} sm={4} styleName='title-nav-nav'>
              <nav styleName='page-nav'>
                <div styleName='page-nav-title'>
                  Contents
                </div>
                {
                  [
                    ['Getting started','getting-started'],
                    ['Fossil fuel companies','companies'],
                    ['Mutual fund grades','fossil-fuel-grades'],
                    // ['Fund managers','fund-manager-ratings'],
                    ['Spreadsheet','spreadsheet'],
                  ].map((e, i) => {
                    return <ScrollLink
                      key={'nav-scroll-link-'+i}
                      to={e[1]}
                      spy
                      smooth
                      duration={500}
                      title={e[0]}
                    >
                      <div styleName='page-nav-btn'>
                        {e[0]}
                      </div>
                    </ScrollLink>
                  })
                }
              </nav>
            </Col>
          </Row>
        </ContainerDivs>

        <Works/>

        <ContainerDivs>
          <section styleName='methodology-section'>
            <div styleName='anchor' id='getting-started'/>
            <h2 styleName='section-title'>
              Getting started
            </h2>

            <Link to={config.routes.videoTutorials} title='Video tutorials'>
              <div styleName='bn-flex'>
                <div styleName='bn-copy'>
                  <div styleName='bn-title'>
                    Video tutorials
                  </div>
                  <div styleName='bn-lede'>
                    Watch our video tutorials to learn the basics of Fossil Free Funds.
                  </div>
                  <div styleName='bn-button'>
                    Watch now<LinkIcon />
                  </div>
                </div>
                <div styleName='bn-img' title='Video tutorials'/>
              </div>
            </Link>

            <h3 styleName='answer-title'>
              Finding your funds
            </h3>
            <div styleName='answer-info'>
              <p>
                We source data on
                companies and mutual funds from financial services provider
                Morningstar. Our database
                covers thousands of U.S. open-end mutual funds and
                exchange-traded funds (ETFs), some of the most common funds held in
                401(k)s, 403(b)s, and other retirement plans.
              </p>
              <p>
                Search for funds by name, ticker, or asset
                manager. Use the search bar below, or <Link
                  to={config.routes.clean}
                  title='Search funds'
                  xstrong
                >use the search page</Link> to do more advanced searches, 
                such as filtering funds by investing style or 
                asset manager. When you find a fund you're looking for,
                click it to see the full results.
              </p>

              <div styleName='search-bar-wrap'>
                <AutocompleteSearch />
              </div>

              <br/>

              <p>
                We don't have everything in our database &mdash; we only analyze
                U.S. mutual funds and ETFs 
                that are at least 50% invested in stock holdings,
                and our data license restricts us to
                displaying only a few thousand portfolios.
              </p>
              <p>
                Looking for your favorite fund and
                can&rsquo;t find it? With more resources, we could include more
                funds &mdash; <Link
                  to={config.links.donate}
                  title='Donate to As You Sow'
                  xstrong
                >make a gift today to make a difference.</Link>
              </p>

              <div styleName='sidebar'>
                <div styleName='sidebar-title'>
                  <LinkIcon faclass='fa-info-circle' nospace/>
                  &nbsp;
                  <em>Our research universe</em>
                </div>
                <div styleName='sidebar-info'>
                  <p>
                    Our database covers open-end mutual funds and exchange-traded funds domiciled in the U.S. Currently, we don’t have data on funds domiciled outside the U.S. The fund ratings are based on tracking stock investments in publicly-traded companies. Currently, we don’t have ratings for fixed income funds. We exclude funds with less than 50% of fund assets in equity holdings from the analysis universe.
                  </p>
                </div>
              </div>
            </div>
            <ScrollToTop />
          </section>

          <FossilFuelCompaniesContent />

          <section styleName='methodology-section'>
            <div styleName='anchor' id='fossil-fuel-grades'/>
            <h2 styleName='section-title'>
              Mutual fund grades
            </h2>
            <h3 styleName='answer-title'>
              Calculating exposure to fossil fuel companies
            </h3>
            <div styleName='answer-info'>
              <p>
                Mutual funds can have a varying number of holdings, from less than one hundred to several thousand. For each fund, we calculate the total number, dollar amount, and percentage of the fund’s assets that are invested in those companies.
              </p>
              <p>
                We only look for direct stock holdings in fossil fuel companies. That means that holdings that are not stocks, like cash holdings or bonds, are not rated. In the fund's investment profile, we show a "Percent Rated" metric, equivalent to the percent of the fund that is invested in stocks. The higher a fund&rsquo;s Percent Rated value, the more holdings we were able to examine. A fund with a lower Percent Rated value may have hidden fossil fuel-related investments that our tool cannot account for, in the form of bond holdings or other asset types.
              </p>
              <div styleName='sidebar'>
                <div styleName='sidebar-title'>
                  <LinkIcon faclass='fa-info-circle' nospace/>
                  &nbsp;
                  <em>Measuring long holdings only</em>
                </div>
                <div styleName='sidebar-info'>
                  <p>
                    When calculating a fund's exposure to a screen list, we only consider the portfolio's long investments, ignoring any shorts or liabilities. The formula for holding weight is <em>holding market value divided by the sum of the market value for all long holdings in the portfolio.</em>
                  </p>
                </div>
              </div>
            </div>

            { /* FOSSIL FUEL BANKS AND INSURANCE */ }
            <h3 styleName='answer-title'>
              Banks and insurance: fossil fuel financial services
            </h3>
            <div styleName='answer-info'>
              <p>
                Fossil Free Funds now incorporates fossil finance into our
                fossil fuel ratings.
              </p>
              <p>
                By continuing to finance and underwrite fossil fuels, banks and
                insurance companies are not only responsible for exacerbating
                climate impacts, but they are also exposing investors to
                financial risk.
              </p>
              <p>
                Our new fund ratings use data on bank lending and insurance
                company policies to assess portfolio exposure to
                finance-industry climate risk.
              </p>
              <p>
                <Link
                  to={config.routes.banksInsurance}
                  title='Fossil fuel lending & insurance'
                  xstrong
                >Learn more about our new fossil fuel finance and
                fossil fuel insurance ratings<LinkIcon/></Link>
              </p>
            </div>

            <h3 styleName='answer-title'>
              Fossil fuel grades
            </h3>
            <div styleName='answer-info'>
              <p>Based on the fund's fossil fuel exposure, it earns one of five grades.</p>
              <div styleName='risk-bullets'>
                <div styleName='risk-bullet'>
                  <Grade grade={1} />
                  <p styleName='screen-icon-label'>
                    No holdings flagged for our fossil fuel screens. Assigned a grade of A.
                  </p>
                </div>
                <div styleName='risk-bullet'>
                  <Grade grade={2} />
                  <p styleName='screen-icon-label'>
                    Fossil fuel exposure between 0% and 3%; OR, fossil fuel
                    exposure is 0%, but fossil fuel finance and insurance exposure
                    is above 0%. Assigned a grade of B.
                  </p>
                </div>
                <div styleName='risk-bullet'>
                  <Grade grade={3} />
                  <p styleName='screen-icon-label'>
                    Fossil fuel exposure between 3% and 5.5%; OR, fossil fuel
                    exposure below 3%, with investments in <b>higher risk</b> companies
                    (top carbon reserve owners and/or top coal-fired utilities).
                    Assigned a grade of C.
                  </p>
                </div>
                <div styleName='risk-bullet'>
                  <Grade grade={4} />
                  <p styleName='screen-icon-label'>
                    Fossil fuel exposure between 5.5% and 9%.
                    Assigned a grade of D.
                  </p>
                </div>
                <div styleName='risk-bullet'>
                <Grade grade={5} />
                <p styleName='screen-icon-label'>
                  Fossil fuel exposure between 9% and 100%.
                  Assigned a grade of F.
                </p>
                </div>
              </div>
            </div>

            <h3 styleName='answer-title'>
              Details on fossil fuel exposure
            </h3>
            <div styleName='answer-info'>
              <p>
                Along with the fossil fuel grade, we show details on the
                fund portfolio's flagged holdings.
              </p>
              <p>
                The number of flagged holdings, the amount invested by the fund,
                and the percent of the fund's portfolio those holdings make up
                are shown. The same figures are available for the
                various sub-categories, and for each individual flagged holding.
              </p>
            </div>

            { /* CARBON FOOTPRINT */ }
            <h3 styleName='answer-title'>
              Carbon footprint
            </h3>

            <FootprintDeprecated />
            
            <div styleName='answer-info'>
              <p>
                A fund's carbon footprint is based on the annual GHG emissions of
                each company invested in by fund. To independently
                analyze and calculate carbon footprints for the mutual funds,
                we used the powerful <Link
                  to={config.routes.carbonfootprint}
                  xstrong
                  title='Carbon footprint'
                >"Carbon Footprint Analysis Tool" of yourSRI.com,</Link> which
                provides the data on corporate emissions worldwide - comprised
                of more than 40,000 companies.
              </p>
              <p>
                We show two key metrics related to carbon emissions - the fund's
                relative carbon footprint, and the relative carbon intensity.
                The carbon footprint is based on amount of emissions per unit
                of <i>investment</i>, while the intensity is based on amount
                of emissions per unit of <i>revenue</i>.
              </p>
              <p>
                For these two metrics, we compare the fund's results to a slate
                of 20 benchmarks from major index providers like MSCI,
                FTSE/Russell, S&P, and Morningstar. Using iShares ETFs as a
                stand-in for each index, we calculate the carbon footprint and
                divide the benchmarks into quartiles, labeled:
              </p>
              <p>
                <span styleName='low'>
                  Low<LinkIcon faclass='fa-circle'/>
                </span> &mdash; Fund footprint/intensity is within the range of
                the bottom 25% of benchmarks
              </p>
              <p>
                <span styleName='avg'>
                  Below median<LinkIcon faclass='fa-circle'/>
                </span> &mdash; Fund footprint/intensity is within the range of
                the second 25% of benchmarks
              </p>
              <p>
                <span styleName='high'>
                  Above median<LinkIcon faclass='fa-circle'/>
                </span> &mdash; Fund footprint/intensity is within the range of
                the third 25% of benchmarks
              </p>
              <p>
                <span styleName='very-high'>
                  High<LinkIcon faclass='fa-circle'/>
                </span> &mdash; Fund footprint/intensity is within the range of
                the top 25% of benchmarks
              </p>
              <p>
                <span styleName='extreme'>
                  Very high<LinkIcon faclass='fa-circle'/>
                </span> &mdash; Fund footprint/intensity is higher than all 20
                benchmarks
              </p>
              <p>
                We recalculate the benchmark quartiles each month based on their
                corresponding iShares ETFs.
              </p>
              <p>
                We also show the emissions weight of the top 10 holdings in the
                fund. If a holding's emissions weight is higher than its
                portfolio weight, it means the holding is responsible for an
                outsized amount of the fund's carbon footprint.
              </p>
            </div>


            <h3 styleName='answer-title'>
              Sustainable funds
            </h3>
            <div styleName='answer-info'>
              <img
                styleName='sri'
                src={sriIcon}
                alt='Sustainably-mandated  fund'
                data-multiline
                data-effect='solid'
                data-html
                data-for='sri-icons-tooltip'
                data-place='bottom'
                data-tip="<div style='max-width:200px;'>Designated a sustainably-mandated fund by Morningstar. Sustainably-mandated funds consider issues like the environment and human rights.</div>"
              />
              <ReactTooltip id='sri-icons-tooltip'/>
              <p>
                We use Morningstar's "sustainability mandate" indicator to determine which funds are displayed as sustainably-mandated. Sustainably-mandated funds make investment decisions based on issues like environmental responsibility, human rights, or religious views. A sustainably-mandated fund may take a proactive stance by selectively investing in, for example, environmentally-friendly companies, or firms with good employee relations. They may also avoid investing in companies involved in promoting alcohol, tobacco, or firearms, or in the defense industry. Look for this symbol to find funds that are designated sustainably-mandated.
              </p>
              <img
                styleName='ussif'
                src={ussifIcon}
                alt='Member of US-SIF, the Forum for Sustainable and Responsible Investment'
                data-multiline
                data-effect='solid'
                data-html
                data-for='ussif-icons-tooltip'
                data-place='bottom'
                data-tip="<div style='max-width:200px;'>Member of US-SIF, the Forum for Sustainable and Responsible Investment</div>"
              />
              <ReactTooltip id='ussif-icons-tooltip'/>
              <p>
                The Forum for Sustainable and Responsible Investment is a group advancing sustainable, responsible, and impact investing. Asset managers who are members of US-SIF often have policies to exclude or restrict investments in companies involved in the production, licensing, and/or retailing of weapons. Look for this symbol to find funds that are members of US-SIF.
              </p>
            </div>

            <h3 styleName='answer-title'>
              Fossil free action toolkit
            </h3>
            <div styleName='answer-info'>
              <p>
                When you're done looking up funds and finding the data you need, what's next? You can learn how to make a change and move your money with our <Link to={config.routes.toolkit} xstrong title='Fossil free action toolkit'>fossil free action toolkit</Link>. Whether you’re an individual investor or if your investments are in your employer-sponsored plan at work, our step-by-step toolkit can help. There's an in-depth guide to responsible investing, links to external resources, a sample letter to send to your employer 401(k) manager, and more &mdash; everything you need to make a change and get started investing your money fossil free.
              </p>
            </div>

            <ScrollToTop />
          </section>

          { /* CHANGELOG */ }
          <section styleName='methodology-section'>
            <div styleName='anchor' id='spreadsheet'/>
            <h2 styleName='section-title'>
              Spreadsheet
            </h2>
            <Changelog />
            <ScrollToTop />
          </section>

        </ContainerDivs>
        <br/>
        <br/>
        <br/>

        <GetStartedInput />
      </div>
    )
  }
}
